<template>
	<div>
		<div v-show="loading">
			<b-spinner style="display: block; margin: auto;"/>
		</div>
		<div v-show="!loading">
			<p>Please select a .syl file that you have downloaded from <b>Export Syllabus Data</b></p>
			<b-form-file @input="sanityCheck" ref="upload" accept=".syl" v-model="file"/>
			<b-alert variant="danger" :show="ready && !isValidFile">This is not a valid syllabus file</b-alert>
		</div>
	</div>
</template>

<script>
export default {
	computed: {
		ready(){
			return this.file != null && !this.loading
		},
		isValidFileNoManual(){
			if (!this.file)
				return false;

			if (!this.file.name.toLowerCase().endsWith('.syl'))
				return false;
			return true;
		},
		isValidFile(){
			return (this.loadedContents != null) || this.isValidFileNoManual && this.manualValidationPassed;
		}
	},
	methods: {
		sanityCheck(){
			this.$set(this, "loadedContents", null);
			this.manualValidationPassed = false;
			this.loading = false;

			if (this.file && !this.isValidFileNoManual)
				return;
			
			this.loading = true;
			let reader = new FileReader();
			reader.onload = (data)=>{
				console.log('loaded')
				this.loading = false;
				let read = data.target.result;
				if (!read)
					return;

				console.log('read passed')
				let parsed = JSON.parse(read)
				if (!parsed)
					return;
				
				console.log('parse passed')
				if (parsed.initialized && parsed.file_name && parsed.course_title)
				{
					let date = new Date();
					parsed.file_name = `syllabus_${date.getFullYear()}_${date.getMonth() + 1}_${date.getDate()}_${date.getHours()}_${date.getMinutes()}_${date.getSeconds()}`;
					console.log('passed schema check')
					this.manualValidationPassed = true;
					this.$set(this, "loadedContents", parsed);
				}
			}
			reader.readAsText(this.file);
		}
	},
	data() {
		return {
			/**  
			    @type {File}
			*/  
			file: null,
			manualValidationPassed: false,
			loadedContents: null,
			loading: false,
		}
	}
}
</script>

<style lang="scss" scoped>

</style>
